var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56657 8.17233L12.0978 4.85836C12.2887 4.74383 12.5234 4.74383 12.7144 4.85836L16.1981 6.94527C16.5484 7.15433 16.6115 7.65242 16.326 7.95055L15.1455 9.18307C14.9493 9.38849 14.6428 9.4303 14.4011 9.28487L12.7196 8.27777C12.5252 8.16142 12.2852 8.16142 12.0908 8.27777L6.2583 11.8081V8.72678C6.2583 8.49773 6.37565 8.28686 6.56657 8.17233Z",
    fill: "#FA8C16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2104 17.0456L12.7126 19.1416C12.5217 19.2561 12.287 19.2561 12.0978 19.1416L6.56657 15.8276C6.37565 15.7131 6.2583 15.5022 6.2583 15.2732V12.4791L9.108 10.7648V13.5662C9.108 13.7952 9.22536 14.0061 9.41627 14.1188L12.0978 15.7258C12.2887 15.8403 12.5234 15.8403 12.7126 15.7258L14.4098 14.7096C14.6515 14.5642 14.9563 14.606 15.1525 14.8114L16.3365 16.0403C16.6237 16.3366 16.5607 16.8365 16.2104 17.0456Z",
    fill: "#1F1F1F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrust);
export default __webpack_public_path__ + "static/media/crust.cc27ced9947bdb01923a735c00cbce6b.svg";
export { ForwardRef as ReactComponent };